export default function ShareRumbleIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
    >
      <g clipPath='url(#clip0_513_1774)'>
        <path
          d='M12.333 10.7202C11.8263 10.7202 11.373 10.9202 11.0263 11.2335L6.27301 8.46683C6.30634 8.3135 6.33301 8.16016 6.33301 8.00016C6.33301 7.84016 6.30634 7.68683 6.27301 7.5335L10.973 4.7935C11.333 5.12683 11.8063 5.3335 12.333 5.3335C13.4397 5.3335 14.333 4.44016 14.333 3.3335C14.333 2.22683 13.4397 1.3335 12.333 1.3335C11.2263 1.3335 10.333 2.22683 10.333 3.3335C10.333 3.4935 10.3597 3.64683 10.393 3.80016L5.69301 6.54016C5.33301 6.20683 4.85967 6.00016 4.33301 6.00016C3.22634 6.00016 2.33301 6.8935 2.33301 8.00016C2.33301 9.10683 3.22634 10.0002 4.33301 10.0002C4.85967 10.0002 5.33301 9.7935 5.69301 9.46016L10.4397 12.2335C10.4063 12.3735 10.3863 12.5202 10.3863 12.6668C10.3863 13.7402 11.2597 14.6135 12.333 14.6135C13.4063 14.6135 14.2797 13.7402 14.2797 12.6668C14.2797 11.5935 13.4063 10.7202 12.333 10.7202Z'
          fill='#0D1333'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_1774'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0.333008)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
